import { StepMap } from "@/components/onboarding/components/welcome-wizard/onboarding-steps.types";
import { SystemPermissionsMeetingPermissionsStep } from "./meeting-permissions-step";

export const SystemPermissionsMeetingsStepsMap: StepMap = {
  "system-permissions-meeting-permissions": {
    id: "system-permissions-meeting-permissions",
    render: props => <SystemPermissionsMeetingPermissionsStep {...props} />,
  },
} as const;
